<template>
  <div id='app'>
    <router-view />
  </div>
</template>
<script>
import { flexible } from 'utils'

export default {
  beforeMount () {
    flexible()
  },
}

var _hmt = _hmt || [];
(function () {
  var hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?1ff1c3880a1e1abc9ad2aa1eb61fbc79'
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
})()
</script>
<style lang='less'>
img {
  border: none;
}
img[lazy=loading], img.swiper-lazy-loading, .adaption-loading {
  background: url('//oss.baobaobooks.net/misc/store_place_new.png') no-repeat center;
  background-size: 25%;
}
.lazyload-holder {
  content: '';
  position: absolute;
  background: url('//oss.baobaobooks.net/misc/store_place_new.png') no-repeat center;
  background-size: 25%;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
img[lazy=error], .lazyerror {
  background: url('//oss.baobaobooks.net/misc/no_pic.png') no-repeat center;
  background-size: 75%;
}
img:not([src], .swiper-lazy-loading){
  visibility: hidden;
}
</style>
